module.exports = __webpack_public_path__ + "img/2025-05.fc55dfcc.jpg";